import firebase from './firebase.util'

export const logout = () => {
  firebase.auth().signOut()
}
